var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('span',{staticClass:"circle",class:_vm.getColorClassName(_vm.value)}),_c('LabelPicker',{attrs:{"value":_vm.value,"source":_vm.finalSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }